import { render, staticRenderFns } from "./CompradorGrid.vue?vue&type=template&id=080fccfb&scoped=true&"
import script from "./CompradorGrid.vue?vue&type=script&lang=js&"
export * from "./CompradorGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fccfb",
  null
  
)

/* custom blocks */
import block0 from "./CompradorGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports